import { createRoute, Outlet, redirect } from "@tanstack/solid-router";
import { isAdminCapable } from "@bso/shared";
import { appRoute } from "./route";
import { sessionActor } from "@/lib/session-machine";
import { readAccountsStateSync } from "@/lib/accounts";
import { resolveActiveAccountView } from "@/lib/active-account";

export const adminRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/admin",
  beforeLoad: () => {
    const view = resolveActiveAccountView(
      readAccountsStateSync(),
      undefined,
      sessionActor.getSnapshot().context.session,
    );

    if (!isAdminCapable(view.role)) {
      throw redirect({ to: "/profile" });
    }
  },
  component: () => <Outlet />,
});
